import {
  Promotion,
  Refresh,
  Delete,
  Scissor,
  CopyDocument,
  MagicStick,
  Share,
  Loading,
  StarFilled,
  Download,
  BellFilled,
  Star,
  UploadFilled,
  Remove,
  CaretLeft,
  ArrowDown,
  CaretRight,
  ChatSquare,
  EditPen,
  Present,
  Phone,
  Mug,
  Select,
  ArrowDownBold,
  ArrowUpBold,
  Expand,
  Fold,
  CircleClose,
  QuestionFilled,
} from "@element-plus/icons-vue";

const icons = [
  Promotion,
  Refresh,
  Delete,
  Scissor,
  CopyDocument,
  MagicStick,
  Share,
  Loading,
  StarFilled,
  Download,
  BellFilled,
  Star,
  UploadFilled,
  Remove,
  ArrowDown,
  CaretLeft,
  CaretRight,
  ChatSquare,
  EditPen,
  Present,
  Phone,
  Mug,
  Select,
  ArrowDownBold,
  ArrowUpBold,
  Expand,
  Fold,
  CircleClose,
  QuestionFilled,
];

export default {
  install: (app) => {
    icons.forEach((item) => {
      app.component(item.name, item);
    });
  },
};
